import { BaseExportService } from "./BaseExportService";

const checkStatusMap = {
  0: 'Failed',
  1: 'Passed',
  2: 'Not Done',
};

export class OcrExportService extends BaseExportService {
  constructor(data, metadata = {}) {
    super(data, metadata);
    this.details = data?.document_details || {};
    this.authenticity = data?.document_authenticity || {};
    this.name_match = data?.name_match || {};
  }

  get_filename_prefix() {
    return `OCR_Report_${this.details?.["Document Number"] || "Unknown"}`;
  }

  get_available_sections() {
    return {
      document_details: "Document Details",
      authenticity_checks: "Authenticity Checks",
      name_match: "Name Match Results",
      image_quality: "Image Quality",
      raw_json: "Raw JSON Data",
    };
  }

  get_default_export_options() {
    return {
      document_details: true,
      authenticity_checks: true,
      name_match: true,
      image_quality: false,
      raw_json: false,
    };
  }

  prepare_export_data(export_options) {
    const export_data = {};

    if (export_options.document_details) {
      export_data.document_details = [this.details];
    }

    if (export_options.authenticity_checks) {
      export_data.authenticity_checks = this.prepare_authenticity_checks();
    }

    if (export_options.name_match) {
      export_data.name_match = [this.name_match];
    }

    if (export_options.image_quality) {
      export_data.image_quality = this.prepare_image_quality();
    }

    if (export_options.raw_json) {
      export_data.raw_json = [this.data];
    }

    return export_data;
  }

  prepare_authenticity_checks() {
    // Flatten logic for authenticity can be complex, simplifying for high-level summary
    const checks = this.authenticity?.AuthenticityCheckList?.List || [];
    return checks.map((check, index) => ({
      "Check #": index + 1,
      Type: check.Type,
      Result: checkStatusMap[check.Result] || "Unknown",
    }));
  }

  prepare_image_quality() {
    return this.authenticity?.ImageQualityChecks || [];
  }
}
